import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
//import "./Special/special.css";
import Button from 'react-bootstrap/Button';
import BadgesExtraCreditCodes from './datasets/badges_extra_credit_codes';
import getTrophyInfo from '../../objects/CommonUse/get_trophy_info';
import AwardDetailListCard from './award_detail_list_card';


class AwardPlayerDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        badgesExtraCreditCodes:  BadgesExtraCreditCodes,
      }    
    this.awardDetailArr = [];
    this.processBadgeArr();
    this.processExtraCreditArr();
    this.processAchievementArr();  
    this.removeDupAwardTypes();
   
}

processBadgeArr(){
    let beginItemNbr = 10;
    for (let i=0; i<this.props.badges.length; i++){
        let badgesArr = this.props.badges[i];
        const badgeCodeLength = badgesArr.badgeCode.length - 1;
        const badgePartNbr = (badgesArr.badgeCode).substring(badgeCodeLength);
        const badgeCode = (badgesArr.badgeCode).substring(0,badgeCodeLength);
        const badgesCodeInfo = 
          this.state.badgesExtraCreditCodes.find(elem => elem.badgeCode === badgeCode);
        const badgeIndx = this.awardDetailArr.findIndex(elem => elem.awardCode === badgeCode);
        if (badgeIndx === -1){
            const itemNbr = beginItemNbr + badgesCodeInfo.badgeNbr;
            const awardObj = {itemNbr:  itemNbr, awardType: "Badge", awardCode: badgeCode, 
              awardName: badgesCodeInfo.topic + " - Part " + badgePartNbr + " Only"};
            this.awardDetailArr.push(awardObj);
        }else{
            const badgeTitleArr = this.awardDetailArr[badgeIndx].awardName.split('-');
            const badgeTitle = badgeTitleArr[0]; 
            this.awardDetailArr[badgeIndx].awardName = badgeTitle;
        }
       
    }
 }

processExtraCreditArr() {
    let beginItemNbr = 40;
    for (let i=0; i<this.props.extraCredit.length; i++){
        const extraCredit = this.props.extraCredit[i];
        const extraCreditCategory = extraCredit.category;
        const extraCreditObj = 
          this.state.badgesExtraCreditCodes.find(elem => elem.extraCreditCategory === extraCreditCategory);
        const itemNbr = beginItemNbr + extraCreditObj.badgeNbr;
        const awardObj = {itemNbr: itemNbr, awardType: "Extra Credit", awardCode: extraCreditObj.badgeCode, 
          awardName: extraCreditObj.topic};
        this.awardDetailArr.push(awardObj);
    }
 };

processAchievementArr(){
    let beginItemNbr = 60;
    for (let i=0; i<this.props.achievements.length; i++){
        const achievement = this.props.achievements[i];
        if (achievement.earned === true){
          const achievementType = achievement.achievementID.substring(0,1);
          const achievementInfo = getTrophyInfo(achievementType);
          let awardType = achievementInfo.medalType;
          if (achievementType !== "J"){
              awardType +=  " Trophy";
          }
          const itemNbr = beginItemNbr + achievementInfo.medalNbr;
          const achievementObj = {itemNbr: itemNbr, awardType: awardType, awardCode: achievement.achievementID,
              awardName: achievement.achievementTitle};
          this.awardDetailArr.push(achievementObj);
        }
    }
}

removeDupAwardTypes(){
    this.awardDetailArr.sort((a, b) => (a.itemNbr + a.awardCode > b.itemNbr + b.awardCode) ? 1 : -1);
    let prevAwardType = "";
    for (let i=0; i<this.awardDetailArr.length; i++){
        if (this.awardDetailArr[i].awardType === prevAwardType){
            this.awardDetailArr[i].awardType = "";
        }else{
            prevAwardType = this.awardDetailArr[i].awardType;
        }
    }
}

render() {
        this.playerAwardDetail = this.awardDetailArr.map((rptInfo, index) =>
          <AwardDetailListCard rptInfo={rptInfo}  key={index} />
          );
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="lg" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Awards and Extra Credit Earned By {this.props.playerName} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <span>
              <table className="table table-hover table-no-space">
                <tbody>
                  <tr>
                    <th>Award Type</th>
                    <th>Award Code</th>
                    <th>Award Title</th>
                  </tr>
                    {this.playerAwardDetail}
                </tbody>
              </table>
                             
              </span>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                  Close
            </Button>
              
        </Modal.Footer>
       
    </Modal>
    
  </>
  }

}

export default AwardPlayerDetailModal;